const isConfigDashboardDisabled =
  process.env.VUE_APP_FEATURE_CONFIG_DASHBOARD === 'disabled'

export const configDashboardRoutes = isConfigDashboardDisabled
  ? []
  : [
      {
        name: 'config-dashboard-index',
        path: '/configuracao-dashboard',
        component: () => import('./ConfigDashboardIndex')
      },
      {
        name: 'config-dashboard-create',
        path: '/configuracao-dashboard/novo',
        component: () => import('./ConfigDashboardCreate')
      },
      {
        name: 'config-dashboard-edit',
        path: '/configuracao-dashboard/editar/:id',
        component: () => import('./ConfigDashboardEdit')
      }
    ]
